import { Button } from "components/ui/button/Button";
import { useSetApplicationStepAnswerMutation, VisibleStepMetadata, useUpdateStepAnswerCyberSecurityAuditLogMutation, useUpdateCreditConsentMutation } from "pages/application/applicationService";
import "./informational.scss";
import { getStepData } from "pages/application/question/questionSlice";
import { useSelector } from "react-redux";
import { getCurrentUserApplicationId, getCurrentUserId, getNhDealApplicationId } from "features/authSlice";
import DisclaimerText from "components/ui/disclaimer-text/DisclaimerText";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { SkipButton } from "pages/application/question/Question";
import { Consent } from "components/consent/Consent";
import * as Constant from "utilities/Constant";
import { useGetFeatureFlagsQuery } from "services/common/featureFlagService";
import { trackFSStepCompleted } from "utilities/full-story";

const Informational = () => {
  const stepData = useSelector(getStepData);
  const stepCode = stepData.stepCodeText;
  const { nextStepActions: stepActions, texts: paragraph, disclaimer, skipAction, label } = stepData;
  const { data: featureFlag } = useGetFeatureFlagsQuery();
  const stepActionId = stepActions[0].stepActionId;
  const isStepCodeF3 = stepData.stepCodeText == "F3";
  const [updateCyberSecurityAuditLog] = useUpdateStepAnswerCyberSecurityAuditLogMutation();

  // Update Credit Consent
  const nhDealApplicationId = useSelector(getNhDealApplicationId);
  const userId = useSelector(getCurrentUserId);
  const [UpdateCreditConsent] = useUpdateCreditConsentMutation();

  const [updateApplication] = useSetApplicationStepAnswerMutation({
    fixedCacheKey: "updateApplication",
  });
  const applicationId = useSelector(getCurrentUserApplicationId);

  const handleSubmit = async () => {
    await updateApplication({
      id: applicationId,
      stepActionId,
    });
    if (isStepCodeF3) {
      await UpdateCreditConsent({
        userId,
        nhDealApplicationId,
      });
    }
    trackFSStepCompleted(stepCode, label, false);
    void updateCyberSecurityAuditLog(applicationId);
  };

  return (
    <div className="information">
      {paragraph.length != 0 && (
        <div className="information__paragraph">
          {paragraph.map(({ header, text, childItems, headerType }: VisibleStepMetadata) => (
            <div key={text}>
              {header && <h6>{header}</h6>}
              <div className={headerType == "timeToComplete" ? "timer_paragraph-container" : "paragraph-container"}>
                {headerType == "timeToComplete" && <FontAwesomeIcon icon={solid("timer")} className="timer-icon" />}
                <p className="timer_paragraph" data-testid="informational-paragraph">{text}</p>
              </div>
              <ul>
                {childItems?.map(({ text }: VisibleStepMetadata) => (
                  <li key={text}  data-testid="informational-list-item">{text}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
      <Button title={stepActions[0].label} onClick={handleSubmit} className="informational-button" />
      {isStepCodeF3 && featureFlag?.splitConsentEnabled && <Consent text={Constant.CREDIT_PAGE_CONSENT} />}
      {skipAction && <SkipButton skipAction={skipAction} />}
      {disclaimer && <DisclaimerText Header={disclaimer.header} Text={disclaimer.text} hasIcon />}
    </div>
  );
};

export default Informational;
